import { render, staticRenderFns } from "./ModalRemoveItemFromForm.vue?vue&type=template&id=13d14a6e&scoped=true"
import script from "./ModalRemoveItemFromForm.vue?vue&type=script&lang=js"
export * from "./ModalRemoveItemFromForm.vue?vue&type=script&lang=js"
import style0 from "./ModalRemoveItemFromForm.vue?vue&type=style&index=0&id=13d14a6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d14a6e",
  null
  
)

export default component.exports